import { render, staticRenderFns } from "./CloseMenu.vue?vue&type=template&id=215e8b5f&"
import script from "./CloseMenu.vue?vue&type=script&lang=js&"
export * from "./CloseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CloseMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports